import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import { ContentType } from "@transfr-inc/dashboard-components/curriculum";
import { listOfExemptedSims } from "@views/my-work/components/course/course.utils";

import { getOohStatusConfig, getStatusConfig } from "./cell.utils";

import "./course-cell.scss";

export function CourseCell({ value }) {
  const {
    exempt,
    contentType,
    masteryScore,
    masteryStatus,
  } = value || {};

  if (listOfExemptedSims.includes(value?.learningExperienceId)) {
    return <div className={clsx("assessment-cell", "ban")}>N/A</div>;
  }

  if (exempt) {
    return (
      <div className={clsx("assessment-cell", "ban")}>
        <FontAwesomeIcon icon={["fa-regular", "ban"]} />
        Exempt
      </div>
    );
  }

  let config;
  if (
    contentType === ContentType.OutOfHeadset.id ||
    contentType === ContentType.Assessment.id ||
    contentType === ContentType.CurriculumResources.id
  ) {
    config = getOohStatusConfig(masteryStatus, masteryScore);
  } else {
    config = getStatusConfig({
      status: masteryStatus,
      masteryScore,
    });
  }

  const { classname, icon, text } = config;

  return (
    <div className={clsx("assessment-cell", classname)}>
      {icon && <FontAwesomeIcon icon={icon} />}
      {text}
    </div>
  );
}
